import Vue from 'vue'
import G6 from '@antv/g6'
import { getUuid } from './utils'
import './popMenu.css'

export default class FlowChart {
  constructor (vm, dom) {
    if (!(vm && vm instanceof Vue)) {
      throw new Error('构造函数需要传入vue实例')
    }
    if (!(dom && dom instanceof HTMLElement)) {
      throw new Error('必须传入dom或者dom id')
    }
    /**
     * 节点状态颜色的配置，合并默认颜色和配置颜色
     */
    const stateList = {
      success: { color: '#67C23A' }, // 默认颜色
      error: { color: '#F56C6C' },
      normal: { color: '#409EFF' },
      start: { color: '#909399' },
      end: { color: '#909399' },
      ...vm.statusColor // 传入的配置颜色
    }
    /**
     * 自定义节点-------流程节点
     */
    G6.registerNode(
      'flowNode',
      {
        draw (cfg, group) {
          group.addShape('rect', {
            attrs: {
              x: 0,
              y: 0,
              width: 230,
              height: 120,
              stroke: `${stateList[cfg.state] ? stateList[cfg.state].color : stateList.normal.color}`,
              fill: '#fff',
              radius: [5, 5, 0, 0]
            },
            name: 'box'
          })
          group.addShape('rect', {
            attrs: {
              x: 0,
              y: 0,
              width: 230,
              height: 35,
              stroke: `${stateList[cfg.state].color}`,
              fill: `${stateList[cfg.state].color}`,
              radius: [5, 5, 0, 0]
            },
            name: 'titleBg'
          })
          group.addShape('text', {
            attrs: {
              x: 8,
              y: 10,
              width: 50,
              fontSize: 15,
              fill: '#fff',
              text: cfg.label.length > 5 ? cfg.label.substring(0, 5) + '...' : cfg.label,
              textBaseline: 'top'
            },
            name: 'title'
          })
          group.addShape('text', {
            attrs: {
              x: 8,
              y: 45,
              fontSize: 13,
              fill: '#666',
              width: 50,
              text: cfg.propertyOne.length > 15 ? cfg.propertyOne.substring(0, 15) + '...' : cfg.propertyOne,
              textBaseline: 'top'
            },
            name: 'propertyOne'
          })
          group.addShape('text', {
            attrs: {
              x: 8,
              y: 68,
              fontSize: 13,
              fill: '#666',
              text: cfg.propertyTwo.length > 15 ? cfg.propertyTwo.substring(0, 15) + '...' : cfg.propertyTwo,
              textBaseline: 'top'
            },
            name: 'propertyTwo'
          })
          group.addShape('text', {
            attrs: {
              x: 8,
              y: 90,
              fontSize: 13,
              fill: '#666',
              text: cfg.propertyThree.length > 15 ? cfg.propertyThree.substring(0, 15) + '...' : cfg.propertyThree,
              textBaseline: 'top'
            },
            name: 'propertyThree'
          })
          const shape = group.addShape('rect', {
            attrs: {
              x: -2,
              y: -2,
              width: 236,
              height: 126,
              fill: '#000',
              opacity: 0
            },
            name: 'dragMask'
          })
          // 如果是开始节点，不展示删除按钮
          if (cfg.id !== 'start' && vm.showDelBtn) {
            group.addShape('image', {
              attrs: {
                x: 140,
                y: 7,
                width: 20,
                height: 20,
                img: require('./assets/del.png')
              },
              name: 'flowDel'
            })
          }
          // 如果是开始节点，不展示返回按钮
          if (cfg.id !== 'start' && vm.showBackBtn) {
            group.addShape('image', {
              attrs: {
                x: 110,
                y: 7,
                width: 20,
                height: 20,
                img: require('./assets/back.png')
              },
              name: 'flowBack'
            })
          }
          // 是否展示新增按钮
          if (vm.showAddBtn) {
            group.addShape('image', {
              attrs: {
                x: 170,
                y: 7,
                width: 20,
                height: 20,
                img: require('./assets/add.png')
              },
              name: 'flowAdd'
            })
          }
          // 是否展示查看按钮
          if (vm.showViewBtn) {
            group.addShape('image', {
              attrs: {
                x: 200,
                y: 9,
                width: 20,
                height: 17,
                img: require('./assets/view.png')
              },
              name: 'flowView'
            })
          }
          return shape
        },
        afterDraw: (cfg, group) => {
          // 点击新增和点击查看的方法
          // const flowView = group.find(element => element.get('name') === 'flowView')
          // const flowAdd = group.find(element => element.get('name') === 'flowAdd')
          // 如果反选的icon存在
          if (group.find(element => element.get('name') === 'flowBack')) {
            const flowBack = group.find(element => element.get('name') === 'flowBack')
            // 节点反选点击事件
            flowBack.on('click', (e) => {
              this.currentNode = cfg
              // 执行方法展示反选节点的名称
              this.initBackNodeMenu()
              this.backMenu.style.left = `${e.x}px`
              this.backMenu.style.top = `${e.y}px`
              this.backMenu.style.display = 'block'
            })
          }
          // 如果查看存在
          if (group.find(element => element.get('name') === 'flowView')) {
            const flowView = group.find(element => element.get('name') === 'flowView')
            // 点击增加icon弹出菜单
            // 点击眼睛弹出抽屉
            flowView.on('click', (e) => {
              e.preventDefault()
              e.stopPropagation()
              this.vm.isSideBarActive = true
              this.currentNode = cfg
              const { id, label, state, type, propertyOne, propertyTwo, propertyThree, x, y, task = {} } = cfg
              this.vm.selectedNodeHandler({
                id,
                label,
                state,
                propertyOne,
                propertyTwo,
                propertyThree,
                type,
                x,
                y,
                task
              })
            })
          }

          // 如果新增的icon存在
          if (group.find(element => element.get('name') === 'flowAdd')) {
            const flowAdd = group.find(element => element.get('name') === 'flowAdd')
            // 点击增加icon弹出菜单
            flowAdd.on('click', (e) => {
              const popMenu = this.popMenu
              e.preventDefault()
              e.stopPropagation()
              this.currentNode = cfg
              popMenu.style.left = `${e.x}px`
              popMenu.style.top = `${e.y}px`
              popMenu.style.display = 'block'
            })
          }
          // 如果删除的icon存在
          if (group.find(element => element.get('name') === 'flowDel')) {
            const flowDel = group.find(element => element.get('name') === 'flowDel')
            // 删除节点方法
            flowDel.on('click', (e) => {
              this.currentNode = cfg
              // 执行删除节点的方法
              this.deleteNode()
            })
          }
        },
        update (cfg, node) {
          // 更新lable 和 property
          const group = node.getContainer() // 获取容器
          const label = group.get('children')[2] // 获取label
          const propertyOne = group.get('children')[3] // 获取属性一
          const propertyTwo = group.get('children')[4] // 获取属性二
          const propertyThree = group.get('children')[5] // 获取属性三
          // 字的截取
          const labelWord = {
            text: cfg.label.length > 5 ? cfg.label.substring(0, 5) + '...' : cfg.label
          }
          const propertyOneWord = {
            text: cfg.propertyOne.length > 5 ? cfg.propertyOne.substring(0, 15) + '...' : cfg.propertyOne
          }
          const propertyTwoWord = {
            text: cfg.propertyTwo.length > 5 ? cfg.propertyTwo.substring(0, 15) + '...' : cfg.propertyTwo
          }
          const propertyThreeWord = {
            text: cfg.propertyThree.length > 5 ? cfg.propertyThree.substring(0, 15) + '...' : cfg.propertyThree
          }
          label.attr(labelWord) // 更新标题
          propertyOne.attr(propertyOneWord) // 更新属性
          propertyTwo.attr(propertyTwoWord) // 更新属性
          propertyThree.attr(propertyThreeWord) // 更新属性
        },
        setState (name, value, item) {
          const { state } = item._cfg.model
          const group = item.getContainer()
          const shape = group.get('children')[0] // 顺序根据 draw 时确定
          // 给选择中的节点更改边框颜色
          if (name === 'selected') {
            if (value) {
              shape.attr('stroke', '#FF8D1E')
              shape.attr('lineWidth', 2)
            } else {
              shape.attr('stroke', `${stateList[state] ? stateList[state].color : stateList.normal.color}`)
              shape.attr('lineWidth', 1)
            }
          }
        }
      },
      'single-node'
    )
    /**
     * 自定义节点-------条件节点
     */
    G6.registerNode(
      'switchNode',
      {
        draw (cfg, group) {
          group.addShape('image', {
            attrs: {
              x: 0,
              y: 0,
              width: 70,
              height: 58,
              img: require('./assets/if.png')
            },
            name: 'swich'
          })
          const shape = group.addShape('image', {
            attrs: {
              x: 0,
              y: 0,
              height: 58,
              width: 70,
              img: require('./assets/mask.png'),
              cursor: 'pointer',
              opacity: 0
            },
            name: 'mask'
          })
          if (vm.showAddBtn) {
            group.addShape('image', {
              attrs: {
                x: 5,
                y: 18,
                height: 19,
                width: 19,
                img: require('./assets/add.png'),
                cursor: 'pointer',
                opacity: 0
              },
              name: 'swichAdd'
            })
          }
          if (vm.showDelBtn) {
            group.addShape('image', {
              attrs: {
                x: 49,
                y: 18,
                height: 19,
                width: 19,
                img: require('./assets/del.png'),
                cursor: 'pointer',
                opacity: 0
              },
              name: 'swichDel'
            })
          }
          // 是否展示查看按钮
          if (vm.showViewBtn) {
            group.addShape('image', {
              attrs: {
                x: 27,
                y: 21,
                height: 15,
                width: 18,
                img: require('./assets/view.png'),
                cursor: 'pointer',
                opacity: 0
              },
              name: 'swichView'
            })
          }
          return shape
        },
        afterDraw: (cfg, group) => {
          const swich = group.find(element => element.get('name') === 'swich')
          if (swich) {
            const mask = group.find(element => element.get('name') === 'mask')
            // 如果删除的icon存在
            if (group.find(element => element.get('name') === 'swichDel')) {
              const swichDel = group.find(element => element.get('name') === 'swichDel')
              // 删除节点方法
              swichDel.on('click', (e) => {
                this.currentNode = cfg
                this.deleteNode()
              })
              swichDel.on('mouseenter', () => {
                onMouseEnter()
              })
              swichDel.on('mouseleave', () => {
                onMouseLeave()
              })
            }
            // 如果新增的icon存在
            if (group.find(element => element.get('name') === 'swichAdd')) {
              const swichAdd = group.find(element => element.get('name') === 'swichAdd')
              // 新增流程节点
              swichAdd.on('click', (e) => {
                this.currentNode = cfg
                this.createNode()
              })
              swichAdd.on('mouseenter', () => {
                onMouseEnter()
              })
              swichAdd.on('mouseleave', () => {
                onMouseLeave()
              })
            }
            // 点击眼睛弹出抽屉
            if (group.find(element => element.get('name') === 'swichView')) {
              const swichView = group.find(element => element.get('name') === 'swichView')
              swichView.on('click', (e) => {
                e.preventDefault()
                e.stopPropagation()
                this.vm.isSideBarActive = true
                this.currentNode = cfg
                const { id, type, task = {}, x, y } = cfg
                this.vm.selectedNodeHandler({
                  id,
                  type,
                  task,
                  x,
                  y
                })
              })
              swichView.on('mouseenter', () => {
                onMouseEnter()
              })
              swichView.on('mouseleave', () => {
                onMouseLeave()
              })
            }
            // 移入移出事件
            const onMouseEnter = () => {
              mask.attr('opacity', 1)
              if (group.find(element => element.get('name') === 'swichDel')) {
                group.find(element => element.get('name') === 'swichDel').attr('opacity', 1)
              }
              if (group.find(element => element.get('name') === 'swichAdd')) {
                group.find(element => element.get('name') === 'swichAdd').attr('opacity', 1)
              }
              if (group.find(element => element.get('name') === 'swichView')) {
                group.find(element => element.get('name') === 'swichView').attr('opacity', 1)
              }
            }
            const onMouseLeave = () => {
              mask.attr('opacity', 0)
              if (group.find(element => element.get('name') === 'swichDel')) {
                group.find(element => element.get('name') === 'swichDel').attr('opacity', 0)
              }
              if (group.find(element => element.get('name') === 'swichAdd')) {
                group.find(element => element.get('name') === 'swichAdd').attr('opacity', 0)
              }
              if (group.find(element => element.get('name') === 'swichView')) {
                group.find(element => element.get('name') === 'swichView').attr('opacity', 0)
              }
            }
            swich.on('mouseenter', () => {
              onMouseEnter()
            })
            swich.on('mouseleave', () => {
              onMouseLeave()
            })
            mask.on('mouseenter', () => {
              onMouseEnter()
            })
            mask.on('mouseleave', () => {
              onMouseLeave()
            })
          }
        }
      },
      'single-node'
    )
    /**
     * 自定义节点-------控制节点
     */
    G6.registerNode(
      'controlNode',
      {
        draw (cfg, group) {
          group.addShape('image', {
            attrs: {
              x: 0,
              y: 0,
              width: 70,
              height: 58,
              img: require('./assets/control.png')
            },
            name: 'control'
          })
          const shape = group.addShape('image', {
            attrs: {
              x: 0,
              y: 0,
              height: 58,
              width: 70,
              img: require('./assets/mask.png'),
              cursor: 'pointer',
              opacity: 0
            },
            name: 'mask'
          })
          if (vm.showAddBtn) {
            group.addShape('image', {
              attrs: {
                x: 5,
                y: 18,
                height: 19,
                width: 19,
                img: require('./assets/add.png'),
                cursor: 'pointer',
                opacity: 0
              },
              name: 'controlAdd'
            })
          }
          if (vm.showDelBtn) {
            group.addShape('image', {
              attrs: {
                x: 49,
                y: 18,
                height: 19,
                width: 19,
                img: require('./assets/del.png'),
                cursor: 'pointer',
                opacity: 0
              },
              name: 'controlDel'
            })
          }

          // 是否展示查看按钮
          if (vm.showViewBtn) {
            group.addShape('image', {
              attrs: {
                x: 27,
                y: 21,
                height: 15,
                width: 19,
                img: require('./assets/view.png'),
                cursor: 'pointer',
                opacity: 0
              },
              name: 'controlView'
            })
          }
          return shape
        },
        afterDraw: (cfg, group) => {
          const control = group.find(element => element.get('name') === 'control')
          if (control) {
            const mask = group.find(element => element.get('name') === 'mask')
            // 如果删除的icon存在
            if (group.find(element => element.get('name') === 'controlDel')) {
              const controlDel = group.find(element => element.get('name') === 'controlDel')
              // 删除控制节点
              controlDel.on('click', (e) => {
                this.currentNode = cfg
                this.deleteNode()
              })
              controlDel.on('mouseenter', () => {
                onMouseEnter()
              })
              controlDel.on('mouseleave', () => {
                onMouseLeave()
              })
            }
            // 如果新增的icon存在
            if (group.find(element => element.get('name') === 'controlAdd')) {
              const controlAdd = group.find(element => element.get('name') === 'controlAdd')
              // 新增流程节点
              controlAdd.on('click', (e) => {
                this.currentNode = cfg
                this.createNode()
              })
              controlAdd.on('mouseenter', () => {
                onMouseEnter()
              })
              controlAdd.on('mouseleave', () => {
                onMouseLeave()
              })
            }
            // 点击眼睛弹出抽屉
            if (group.find(element => element.get('name') === 'controlView')) {
              const controlView = group.find(element => element.get('name') === 'controlView')
              // 点击眼睛弹出抽屉
              controlView.on('click', (e) => {
                e.preventDefault()
                e.stopPropagation()
                this.vm.isSideBarActive = true
                this.currentNode = cfg
                const { id, type, task = {}, x, y } = cfg
                this.vm.selectedNodeHandler({
                  id,
                  type,
                  task,
                  x,
                  y
                })
              })
              controlView.on('mouseenter', () => {
                onMouseEnter()
              })
              controlView.on('mouseleave', () => {
                onMouseLeave()
              })
            }

            // 移入移出事件
            const onMouseEnter = () => {
              mask.attr('opacity', 1)
              if (group.find(element => element.get('name') === 'controlDel')) {
                group.find(element => element.get('name') === 'controlDel').attr('opacity', 1)
              }
              if (group.find(element => element.get('name') === 'controlAdd')) {
                group.find(element => element.get('name') === 'controlAdd').attr('opacity', 1)
              }
              if (group.find(element => element.get('name') === 'controlView')) {
                group.find(element => element.get('name') === 'controlView').attr('opacity', 1)
              }
            }
            const onMouseLeave = () => {
              mask.attr('opacity', 0)
              if (group.find(element => element.get('name') === 'controlDel')) {
                group.find(element => element.get('name') === 'controlDel').attr('opacity', 0)
              }
              if (group.find(element => element.get('name') === 'controlAdd')) {
                group.find(element => element.get('name') === 'controlAdd').attr('opacity', 0)
              }
              if (group.find(element => element.get('name') === 'controlView')) {
                group.find(element => element.get('name') === 'controlView').attr('opacity', 0)
              }
            }
            control.on('mouseenter', () => {
              onMouseEnter()
            })
            control.on('mouseleave', () => {
              onMouseLeave()
            })
            mask.on('mouseenter', () => {
              onMouseEnter()
            })
            mask.on('mouseleave', () => {
              onMouseLeave()
            })
          }
        }
      },
      'single-node'
    )
    /**
     * 自定义边
     */
    G6.registerEdge('customEdge', {
      draw (cfg, group) {
        const startPoint = cfg.startPoint
        const endPoint = cfg.endPoint
        const shape = group.addShape('path', {
          zIndex: 1,
          attrs: {
            radius: 0,
            offset: 45,
            endArrow: true,
            lineWidth: 2,
            stroke: '#C2C8D5',
            path: [
              ['M', startPoint.x, startPoint.y],
              ['L', endPoint.x / 3 + (2 / 3) * startPoint.x, startPoint.y],
              ['L', endPoint.x / 3 + (2 / 3) * startPoint.x, endPoint.y],
              ['L', endPoint.x, endPoint.y]
            ]
          }
        })
        return shape
      }
    })
    /**
     * 自定义边反选
     */
    G6.registerEdge('customBackEdge', {
      draw (cfg, group) {
        const startPoint = cfg.startPoint
        const endPoint = cfg.endPoint
        const shape = group.addShape('path', {
          zIndex: 1,
          attrs: {
            radius: 0,
            offset: 45,
            endArrow: true,
            lineWidth: 2,
            lineDash: [4, 2],
            stroke: '#C2C8D5',
            path: [
              ['M', startPoint.x, startPoint.y],
              ['L', startPoint.x, endPoint.y + 25],
              ['L', endPoint.x, endPoint.y + 25],
              ['L', endPoint.x, endPoint.y]
            ]
          }
        })
        return shape
      }
    })

    /**
     * G6实例化
     */
    this.vm = vm
    this.dom = dom
    this.data = null
    this.graph = new G6.Graph({
      container: dom,
      width: this.vm.width, // 配置宽度
      height: this.vm.height, // 配置高度
      modes: {
        default: [
          'drag-canvas', // 拖拽画布
          {
            type: 'zoom-canvas', // 缩放画布
            minZoom: 0.5,
            maxZoom: 1.5
          },
          'drag-node', // 拖拽节点
          'click-select' // 单击选择
        ]
      },
      defaultNode: {
        anchorPoints: [ // 节点上边的入口
          [1, 0.5],
          [0, 0.5],
          [0.5, 1]
        ]
      },
      defaultEdge: {
        type: 'customEdge', // 默认边类型
        style: {
          offset: 0
        }
      }
    })
    // 绘制流程图
    this.graph.fitView()
    // 执行流程节点中新增节点类型的菜单（绘制菜单）
    const initPopMenuConfig = [
      {
        text: vm.addFlowNodeText,
        onClick: () => {
          this.createNode()
        }
      }
    ]
    if (vm.addShowSwitchNode) {
      initPopMenuConfig.push({
        text: vm.addSwitchNodeText,
        onClick: () => {
          this.createNode('switchNode')
        }
      })
    }
    this.initPopMenu(initPopMenuConfig)
    this.initEvent()
    // 键盘弹起事件
    this.graph.on('keyup', (e) => {
      const allNodes = this.graph.findAllByState('node', 'selected')
      // 只过滤出 流程节点 （因为多选只能从流程节点合并绘制控制节点，控制节点和条件节点不能绘制控制节点）
      const nodes = allNodes.filter(node => node._cfg.model.type === 'flowNode')
      // delete删除 46win 8mac
      // if ((e.keyCode === 46 || e.keyCode === 8) && allNodes.length <= 1 && allNodes[0] && allNodes[0].getModel().id !== 'start') {
      //   this.currentNode = allNodes[0]._cfg
      //   this.deleteNode()
      // }
      // 多选
      if (e.keyCode === 16 && nodes.length > 1) {
        // 计算节点位置
        const [x, y] = this.calculatedPosition(nodes[0].getModel())
        const newEdge = []
        const isExistTarget = nodes.find(node => node._cfg.model.targetId) // 为所有绘制了控制节点的节点添加targetID属性
        if (!isExistTarget) {
          // 如果不存在 ，则创建一个控制节点
          const newNode = {
            id: getUuid(),
            type: 'controlNode',
            x,
            y
          }
          nodes.forEach(node => {
            node._cfg.model.targetId = newNode.id
            newEdge.push({
              source: node._cfg.id,
              target: newNode.id,
              type: 'customEdge',
              targetAnchor: 1,
              sourceAnchor: 0
            })
          })
          // 新增返回事件
          const { id, type, x: nodeX, y: nodeY } = newNode
          this.vm.handleAddNode({
            id,
            type,
            x: nodeX,
            y: nodeY,
            task: {}
          })
          this.data.nodes.push(newNode)
          this.data.edges.push(...newEdge)
        } else {
          // 如果存在，则合并进控制节点
          nodes.forEach(node => {
            if (!node._cfg.model.targetId) {
              node._cfg.model.targetId = isExistTarget._cfg.model.targetId
              newEdge.push({
                source: node._cfg.id,
                target: isExistTarget._cfg.model.targetId,
                type: 'customEdge',
                targetAnchor: 1,
                sourceAnchor: 0
              })
            }
          })
          this.data.edges.push(...newEdge)
        }
        this.graph.changeData(this.data)
        // 取消所有选择
        nodes.forEach(node => {
          node.setState('selected', false)
        })
      }
    })
  }

  /**
 * 创建节点  type 为节点类型  currentNode 为当前节点数据
 *          flowNode 流程节点
 *          swicthNode 条件节点
 *          controlNode 控制节点
 */
  createNode (type = 'flowNode') {
    const [x, y] = this.calculatedPosition()
    let newNode = {
      id: getUuid(),
      type,
      x,
      y
    }
    if (type === 'flowNode') {
      newNode = {
        ...newNode,
        label: '节点标题',
        propertyOne: '',
        propertyTwo: '',
        propertyThree: '',
        state: 'normal'
      }
    }
    this.data.nodes.push(newNode)
    this.data.edges.push({
      source: this.currentNode.id,
      target: newNode.id,
      type: 'customEdge',
      targetAnchor: 1,
      sourceAnchor: 0
    })
    // 提供新增事件
    const { id, label, state, type: newType, propertyOne, propertyTwo, propertyThree, x: nodeX, y: nodeY, task = {} } = newNode
    const data = type === 'flowNode' ? {
      id,
      label,
      state,
      propertyOne,
      propertyTwo,
      propertyThree,
      type: newType,
      x: nodeX,
      y: nodeY,
      task
    } : {
      id,
      type: newType,
      task,
      x: nodeX,
      y: nodeY
    }
    this.vm.handleAddNode(data)
    this.graph.changeData(this.data)
  }

  /**
 * 返回节点位置  计算绘制子节点位置
 */
  calculatedPosition (currentNode = this.currentNode) {
    let x
    let y
    const targetEdgesList = this.data.edges.filter(edge => edge.source === currentNode.id && edge.type !== 'customBackEdge') // 并且去除反选线
    if (targetEdgesList.length) {
      const nodes = this.data.nodes.filter(node => node.id === targetEdgesList[targetEdgesList.length - 1].target)
      x = nodes[0].x
      y = nodes[0].y + 38
    } else {
      x = currentNode.x + 350
      y = currentNode.y
    }
    return [x, y]
  }

  /**
 * 删除节点  currentNode 为当前节点数据
 */

  deleteNode (parameterId) {
    const id = parameterId || this.currentNode.id
    // 过滤掉反选的边
    const edges = this.data.edges.filter(edge => edge.type === 'customEdge')
    // 获取 target 的 ID 集合
    const targetIdList = edges.filter(edge => edge.source === id).map(edge => edge.target)
    // 获取 source 的 ID 集合
    const sourceIdList = edges.filter(edge => edge.target === id).map(edge => edge.source)
    targetIdList.forEach(targetId => {
      // 获取 targetId 是在 targetIdList 里的边
      const sourceL = edges.filter((edge) => edge.target === targetId)
      if (sourceL.length === 1) {
        const node = this.graph.findById(targetId)
        const ids = this.getOutNodeIds(node.getOutEdges())
        this.data.nodes = this.data.nodes.filter(node => node.id !== targetId && !ids.includes(node.id))
        this.data.edges = this.data.edges.filter(edge => (!ids.includes(edge.source) && !ids.includes(edge.target)))
        // this.data.edges = this.data.edges.filter(edge => (edge.source !== targetId && edge.target !== targetId))
      }
    })
    this.data.nodes = this.data.nodes.filter(node => {
      if (sourceIdList.includes(node.id)) {
        delete node.targetId
      }
      return node.id !== id
    })
    if (!parameterId) {
      this.vm.handleDeleteNode(this.currentNode)
    }
    this.data.edges = this.data.edges.filter(edge => (edge.source !== id && edge.target !== id))
    this.graph.changeData(this.data)
  }

  /**
 * 获取前置节点列表
 */
  getPreNodeList (nodeId) {
    const sourceIdList = this.data.edges.filter(edge => edge.target === nodeId).map(edge => edge.source)
    return this.data.nodes.filter(node => sourceIdList.includes(node.id))
  }

  /**
 * 获取所有前置节点列表
 */
  // 当前 id
  // 根据当前 id 获取 target 是当前 id 的边，返回 source（相邻前置节点的id 集合）
  // 继续遍历
  getAllPreNodeList (nodeId) {
    if (nodeId === 'start') {
      return []
    }
    var ids = [nodeId]
    let lastSource = []
    while (lastSource[0] !== 'start') {
      lastSource = this.data.edges.filter(edge => ids.includes(edge.target)).map(edge => edge.source)
      ids.push(...Array.from(new Set(lastSource)))
      if (!lastSource.length) {
        lastSource = ['start']
      }
    }
    ids.shift()
    return this.data.nodes.filter(node => ids.includes(node.id))
  }

  /**
 * 删除节点需删除当前节点的子节点 获取出口节点
 */
  getOutNodeIds (outEdges) {
    const ids = []
    const getChildrenIds = (edges, array) => {
      const flowOutEdges = edges.filter(o => o._cfg.model.type === 'customEdge')
      flowOutEdges.forEach(e => {
        const p = e.getTarget()
        array.push(p._cfg.id)
        getChildrenIds(e.getTarget().getOutEdges(), array)
      })
    }
    getChildrenIds(outEdges, ids)
    return ids
  }

  init (data) {
    this.data = data
    this.graph.data(data)
    this.graph.render()
  }

  /**
   * 初始化悬浮新增菜单
   */
  initPopMenu (menuList = []) {
    if (!menuList.length) return
    const popMenu = document.createElement('ul')
    popMenu.addEventListener('mouseleave', () => {
      popMenu.style.display = 'none'
    })
    popMenu.id = 'flow-chart-addMenu'
    menuList.forEach(menu => {
      const li = document.createElement('li')
      li.innerText = menu.text
      li.addEventListener('click', () => {
        menu.onClick(this.currentNode)
      })
      popMenu.appendChild(li)
    })
    this.dom.appendChild(popMenu)
    this.popMenu = popMenu
  }

  /**
   * 反选悬浮菜单
   */
  initBackNodeMenu () {
    const backDom = document.getElementById('flow-chart-BackMenu')
    if (backDom) {
      backDom.remove()
    }
    const menuList = this.data.nodes.filter(node => node.type === 'flowNode' && node.id !== this.currentNode.id)
    const backMenu = document.createElement('ul')
    backMenu.addEventListener('mouseleave', () => {
      backMenu.style.display = 'none'
    })
    backMenu.id = 'flow-chart-BackMenu'
    menuList.forEach(menu => {
      const li = document.createElement('li')
      li.innerText = menu.label
      li.addEventListener('click', () => {
        const isExist = this.data.edges.find(edge => edge.source === this.currentNode.id && edge.target === menu.id)
        if (!isExist) {
          // menu.onClick(this.currentNode)
          this.data.edges.push({
            source: this.currentNode.id,
            target: menu.id,
            type: 'customBackEdge',
            sourceAnchor: 2,
            targetAnchor: 2
          })
          this.graph.changeData(this.data)
        }
      })
      backMenu.appendChild(li)
    })
    this.dom.appendChild(backMenu)
    this.backMenu = backMenu
  }

  // addEventListener
  initEvent () {
    // 点击canvas收起抽屉（后增加mask后取消）
    //   this.graph.on('click', evt => {
    //     const { item } = evt
    //     if (!item) {
    //       this.vm.isSideBarActive = false
    //     }
    //   })
  }

  /**
   * 设置右侧边栏显示隐藏
   * @param {boolean} bool
   */
  setSideBar (bool) {
    this.vm.isSideBarActive = !!bool
  }

  /**
   * 供vm调用: 更新node/edge task
   * @param {object} itemModel 节点
   * @param {string} itemModel.id
   * @param {object} itemModel.task 节点/连线任务对象
   */
  updateItem (itemModel) {
    const { id } = itemModel
    if (!id) {
      throw new Error('更新节点数据模型: 未找到id')
    }
    const node = this.graph.findById(id)
    const { id: nodeId, label, state, type, task, propertyOne, propertyTwo, propertyThree, x, y } = itemModel
    node.update({
      ...this.currentNode,
      id: nodeId,
      label,
      propertyOne,
      propertyTwo,
      propertyThree,
      task,
      type,
      state,
      x,
      y
    })
    this.graph.render()
  }

  /**
   * 供vm调用: 返回图表数据
   */
  getData () {
    return this.data
  }

  /**
   * 供vm调用: 返回图表数据
   */
  fitView (padding) {
    return this.graph.fitView(padding)
  }
}
